import Grow from "@avinet/adaptive-ui-core/layout/Grow";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import { DisplayData } from "./DisplayData";
import { DisplayDataTitle, DisplayDataTitleProps } from "./DisplayDataTitle";

interface DisplayDataEditProps extends DisplayDataTitleProps {
  editLabel?: string;
  onEdit: () => void;
}

export function DisplayDataEdit({
  title,
  description,
  editLabel,
  onEdit,
}: DisplayDataEditProps) {
  const t = useTranslate("Main");

  return (
    <DisplayData>
      <DisplayDataTitle title={title} description={description} />
      <Grow />
      <button onClick={onEdit} className="btn-link primary">
        {editLabel || t("edit")}
      </button>
    </DisplayData>
  );
}
